// Containers
import FooterNavigationItemContainer from "containers/atoms/FooterNavigationItemContainer";

// Hooks
import useTranslate from "hooks/useTranslate";

// Type
import { FooterNavigationType } from "constants/navigation";

import "./styles.sass";

export type FooterMenuProps = {
  title: string;
  list: FooterNavigationType[];
};

const FooterNavigationList: React.FC<FooterMenuProps> = ({ title, list }) => {
  const t = useTranslate();

  return (
    <div className="Footer__navigation_list">
      <div className="Footer__navigation_list_title">{t(title)}</div>
      {list.map((menu) => (
        <FooterNavigationItemContainer item={menu} key={menu.id} />
      ))}
    </div>
  );
};

export default FooterNavigationList;
